<div class="d-grid justify-content-center card-info" [class.card-info-success]="success">
    <button class="btn-close-dialog card-info-close" *ngIf="showCloseBtn" [mat-dialog-close]="false"><i class="fa-light fa-times"></i></button>
    <ng-container *ngIf="success; else defaultIcon">
        <i class="fa-thin fa-circle-check success-icon"></i>
    </ng-container>
    <ng-template #defaultIcon>
        <i *ngIf="icon; else divLogo" class="fa-thin fa-circle-info"></i>
        <ng-template #divLogo>
            <img fallimg src="assets/img/citylok_logo.png" alt="Citylok logo">
        </ng-template>
    </ng-template>
    <p class="text-info-card" [innerHTML]="text">
    </p>
    <mat-radio-group *ngIf="choices" [(ngModel)]="selectedChoice" style="display:flex;flex-direction:column;gap:8px;margin:12px 0;">
        <mat-radio-button *ngFor="let c of choices" [value]="c.value" color="primary">{{ c.label }}</mat-radio-button>
    </mat-radio-group>
    <div class="align-items-center" style="column-gap: 16px;"
        [class]="btnCancel ? 'd-flex justify-content-between' : 'd-grid'"
        [class.warningBtns]="warning">
        <button [class]="warning ? 'primary-button' : 'cancel-button'" *ngIf="btnCancel" [mat-dialog-close]="false">{{ textCancel }}</button>
        <button [class]="warning ? 'cancel-button' : 'primary-button'" [mat-dialog-close]="choices ? selectedChoice : true">{{ textButton }}</button>
    </div>
</div>